const translations = {
  // Common translations
  email: 'Email',
  
  // Common operations and UI elements
  common: {
    create: 'Create',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    view: 'View',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    update: 'Update',
    updating: 'Updating...',
    creating: 'Creating...',
    saveChanges: 'Save Changes',
    saving: 'Saving...',
    confirmDelete: 'Are you sure you want to delete this item?',
    noData: 'No data available',
    noItemsFound: 'No items found',
    itemsPerPage: 'Items per page:', 
    search: 'Search',
    actions: 'Actions',
    show: 'Show',
    entries: 'entries',
    of: 'of',
    retry: 'Retry',
    cannotDeleteAdmin: 'Cannot delete admin user',
    page: 'Page',
    changeLanguage: 'Change Language',
    rowsPerPage: 'Rows per page',
    applyFilters: 'Apply Filters',
    clearFilters: 'Clear Filters',
    refresh: 'Refresh',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Information',
    loading: 'Loading...',
    noOptions: 'No options',
    optional: 'Optional',
    none: 'None',
    back: 'Back',
    selectOption: 'Select an option',
    selectUser: 'Select a user',
    // Delete confirmation dialog
    deleteDialog: {
      cancel: 'Cancel',
      delete: 'Delete',
      title: 'Confirm Delete',
      content: 'Are you sure you want to delete this item? This action cannot be undone.'
    }
  },
  login: {
    title: 'Login',
    email: 'Email',
    password: 'Password',
    submit: 'Sign In',
    error: 'Invalid email or password',
    forgotPassword: 'Forgot Password?',
  },
  // Validation messages
  validation: {
    required: '{{field}} is required',
    email: 'Please enter a valid email address',
    emailExists: 'A user with this email already exists',
    passwordLength: 'Password must be at least {{min}} characters',
    passwordsDontMatch: 'Passwords do not match',
    minLength: 'Must be at least {{min}} characters',
    maxLength: 'Must be at most {{max}} characters',
    invalidFormat: 'Invalid format',
    number: 'Must be a number',
    min: 'Must be at least {{min}}',
    max: 'Must be at most {{max}}',
    invalidPhone: 'Please enter a valid phone number',
    phoneFormat: 'Format: XX XX XX XX (8 digits)'
  },

  // Error messages
  errors: {
    loadData: 'Failed to load data',
    saveData: 'Failed to save data',
    deleteData: 'Failed to delete data',
    loadUser: 'Failed to load user data',
    saveUser: 'Failed to save user. Please try again.',
    deleteUser: 'Failed to delete user',
    unauthorized: 'You are not authorized to perform this action',
    notFound: 'The requested resource was not found',
    serverError: 'A server error occurred',
    networkError: 'Network error. Please check your connection.'
  },

  // Drivers module
  drivers: {
    title: 'Drivers',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    status: 'Status',
    vehicleType: 'Vehicle Type',
    vehicleNumber: 'Vehicle Number',
    addDriver: 'Add Driver',
    editDriver: 'Edit Driver',
    driverInfo: 'Driver Information',
    activity: 'Recent Activity',
    noActivity: 'No recent activity',
    form: {
      name: 'Full Name',
      email: 'Email Address',
      phone: 'Phone Number',
      password: 'Password',
      vehicleType: 'Vehicle Type',
      vehicleNumber: 'Vehicle Registration Number',
      licenseNumber: 'Driver\'s License Number',
      currentLocation: 'Current City',
      rating: 'Rating',
      totalDeliveries: 'Total Deliveries',
    },
    deleteDialog: {
      title: 'Delete Driver',
      content: 'Are you sure you want to delete this driver? This action cannot be undone.',
      cancel: 'Cancel',
      delete: 'Delete',
    },
    statusUpdate: {
      title: 'Update My Status',
      currentStatus: 'Current Status:',
      updateButton: 'Update Status',
      updating: 'Updating...',
      success: 'Status updated successfully!',
      error: 'Failed to update status. Please try again.',
      noUserError: 'Unable to identify current user.',
      locationPlaceholder: 'Enter your current location (optional)',
      locationHelper: 'This helps customers track deliveries'
    },
    statuses: {
      active: 'Active',
      inactive: 'Inactive',
      available: 'Available',
      on_delivery: 'On Delivery'
    },
    vehicleTypes: {
      bike: 'Bicycle',
      bicycle: 'Bicycle', // Alias for bike
      scooter: 'Scooter',
      motorcycle: 'Motorcycle',
      car: 'Car',
      truck: 'Truck',
      van: 'Van'
    },
    stats: {
      total: 'Total Drivers',
      active: 'Active',
      inactive: 'Inactive',
      onDelivery: 'On Delivery'
    },
    notFound: 'Driver not found',
    backToDrivers: 'Back to Drivers',
    passwordRequirements: 'Password must be at least 8 characters long'
  },

  // Users module
  users: {
    title: 'Users',
    name: 'Name',
    email: 'Email',
    role: 'Role',
    actions: 'Actions',
    edit: 'Edit',
    delete: 'Delete',
    create: 'Create User',
    save: 'Save',
    cancel: 'Cancel',
    createTitle: 'Create New User',
    editTitle: 'Edit User',
    deleteConfirm: 'Are you sure you want to delete this user?',
    password: 'Password',
    newPassword: 'New Password (leave blank to keep current)',
    confirmPassword: 'Confirm Password',
    currentPassword: 'Current Password',
    changePassword: 'Change Password',
    passwordRequirements: 'Password must be at least 8 characters long',
    selectRole: 'Select a role',
    resetPassword: 'Reset Password',
    createdAt: 'Created At',
    roles: {
      admin: 'Administrator',
      driver: 'Driver',
      client: 'Client'
    },
    clientPasswordInfo: 'Client users do not require a password and cannot log in to the admin dashboard. They can only track shipments using the public tracking portal.',
  },
  menu: {
    dashboard: 'Dashboard',
    users: 'Users',
    customers: 'Customers',
    drivers: 'Drivers',
    shipments: 'Shipments',
    quotes: 'Quotes',
    zones: 'Zones',
    reports: 'Reports',
    staff: 'Staff',
  },

  // Quotes module
  quotes: {
    title: 'Quotes',
    list: {
      title: 'Quote Management',
      subtitle: 'Manage delivery quotes and pricing requests',
      noQuotes: 'No quotes found',
      loading: 'Loading quotes...',
      error: 'Failed to load quotes',
    },
    detail: {
      title: 'Quote Details',
      backToQuotes: 'Back to Quotes',
      deleteQuote: 'Delete Quote',
      reference: 'Reference',
      status: 'Status',
      createdAt: 'Created',
      updatedAt: 'Updated',
      loading: 'Loading quote...',
      error: 'Failed to load quote',
      notFound: 'Quote not found',
    },
    status: {
      pending: 'Pending',
      reviewed: 'Reviewed', 
      approved: 'Approved',
      rejected: 'Rejected',
      all: 'All Statuses',
      management: 'Status Management',
      update: 'Update Status',
      updating: 'Updating...',
      notes: 'Notes (optional)',
      notesPlaceholder: 'Add notes about this status change...',
      updateSuccess: 'Quote status updated successfully',
      updateError: 'Failed to update quote status',
    },
    delete: {
      title: 'Delete Quote',
      message: 'Are you sure you want to delete quote',
      warning: 'This action cannot be undone.',
      confirm: 'Delete',
      cancel: 'Cancel',
      deleting: 'Deleting...',
      success: 'Quote deleted successfully',
      error: 'Failed to delete quote',
    },
    sender: {
      title: 'Sender Information',
      name: 'Name',
      phone: 'Phone',
      address: 'Address',
    },
    recipient: {
      title: 'Recipient Information', 
      name: 'Name',
      phone: 'Phone',
      address: 'Address',
    },
    package: {
      title: 'Package Information',
      type: 'Type',
      weight: 'Weight',
      dimensions: 'Dimensions',
      value: 'Value',
      description: 'Description',
    },
    delivery: {
      title: 'Delivery Information',
      service: 'Service Type',
      date: 'Delivery Date',
      time: 'Delivery Time',
      instructions: 'Instructions',
      zone: 'Zone',
      estimatedDays: 'Estimated Days',
    },
    pricing: {
      title: 'Pricing Information',
      pricePerKg: 'Price per KG',
      totalPrice: 'Total Price',
      currency: 'Currency',
    },
    filters: {
      search: 'Search quotes...',
      status: 'Filter by Status',
      apply: 'Apply Filters',
      clear: 'Clear Filters',
    },
    pagination: {
      page: 'Page',
      of: 'of',
      rowsPerPage: 'Rows per page',
      previous: 'Previous',
      next: 'Next',
    },
    actions: {
      view: 'View',
      edit: 'Edit',
      delete: 'Delete',
      updateStatus: 'Update Status',
    },
  },

  // Shipments module
  shipments: {
    title: 'Shipments',
    create: {
      title: 'Create Shipment',
      subtitle: 'Fill in the shipment details'
    },
    createNew: 'New Shipment',
    editShipment: 'Edit Shipment',
    trackingNumber: 'Tracking Number',
    originCity: 'Origin (City)',
    destinationCity: 'Destination (City)',
    driver: 'Delivery Agent',
    zone: 'Delivery Zone',
    weight: 'Weight (kg)',
    dimensions: 'Dimensions (L×W×H cm)',
    createdAt: 'Date Created',
    updatedAt: 'Last Updated',
    deliveryDate: 'Expected Delivery',
    noShipments: 'No shipments found',
    loading: 'Loading shipments...',
    error: 'Error loading shipments',
    searchPlaceholder: 'Search by tracking, city, or customer...',
    deleteShipment: 'Delete Shipment',
    deleteConfirmationTitle: 'Confirm Deletion',
    deleteConfirmationMessage: 'Are you sure you want to delete shipment {trackingNumber}? This action cannot be undone.',
    updateStatus: 'Update Status',
    trackingHistory: 'Shipment History',
    noTrackingHistory: 'No history available',
    addNote: 'Add Note',
    assignDriver: 'Assign Agent',
    notesPlaceholder: 'Enter status update notes...',
    
    // Statuses for shipments
    statuses: {
      pending: 'Pending',
      in_transit: 'In Transit',
      out_for_delivery: 'With Delivery Agent',
      delivered: 'Delivered',
      exception: 'Issue Reported',
      returned: 'Returned to Sender',
      all: 'All Statuses'
    },
    
    // Actions
    actions: {
      updateStatus: 'Update Status',
      assignDriver: 'Assign Driver',
      addNote: 'Add Note',
      create: 'Create Shipment',
      edit: 'Edit',
      delete: 'Delete',
      view: 'View',
      track: 'Track',
      printLabel: 'Print Label',
      markAsDelivered: 'Mark as Delivered'
    },
    
    // Error messages
    errors: {
      invalidTrackingNumber: 'Invalid Tracking Number',
      trackingNumberMissing: 'The tracking number is missing or invalid. Please check the URL and try again.'
    },
    
    // Messages
    messages: {
      confirmDelete: 'Are you sure you want to delete this shipment?',
      deleted: 'Shipment deleted successfully',
      deleteError: 'Failed to delete shipment',
      loading: 'Loading shipments...',
      error: 'Error loading shipments',
      retry: 'Retry',
      createSuccess: 'Shipment created successfully',
      updateSuccess: 'Shipment updated successfully',
      updated: 'Shipment updated successfully',
      updateError: 'Failed to update shipment',
      deleteSuccess: 'Shipment deleted successfully',
      noShipments: 'No shipments found',
      searchingFor: 'Searching for',
      resetFilters: 'Reset All Filters',
      loadingShipments: 'Loading shipments...',
      shipmentsLoaded: 'Shipments loaded successfully',
      shipmentUpdated: 'Shipment updated successfully',
      shipmentCreated: 'Shipment created successfully',
      errorLoading: 'Error loading shipments'
    },
    
    // Status translations for forms (singular)
    status: {
      pending: 'Pending',
      in_transit: 'In Transit',
      out_for_delivery: 'With Delivery Agent',
      delivered: 'Delivered',
      exception: 'Issue Reported',
      returned: 'Returned to Sender'
    },
    
    // Field labels
    fields: {
      id: 'ID',
      trackingNumber: 'Tracking Number',
      status: 'Status',
      origin: 'Origin (City)',
      destination: 'Destination (City)',
      customer: 'Customer',
      driver: 'Delivery Agent',
      createdAt: 'Date Created',
      updatedAt: 'Last Updated',
      estimatedDelivery: 'Estimated Delivery',
      actualDelivery: 'Actual Delivery',
      weight: 'Weight (kg)',
      dimensions: 'Dimensions (L×W×H cm)',
      notes: 'Notes',
      customerName: 'Customer Name',
      customerEmail: 'Customer Email',
      customerPhone: 'Customer Phone',
      driverName: 'Driver Name',
      driverContact: 'Driver Contact',
      statusUpdatedAt: 'Status Updated At',
      lastUpdated: 'Last Updated',
      receiverName: 'Recipient Name',
      receiverPhone: 'Recipient Phone',
      receiverAddress: 'Delivery Address',
      receiverCity: 'City',
      receiverCountry: 'Country',
      receiverPostalCode: 'Postal Code',
      zone: 'Delivery Zone'
    },
    
    // Filtering and searching
    filter: {
      all: 'All Shipments',
      today: 'Today',
      thisWeek: 'This Week',
      thisMonth: 'This Month',
      dateRange: 'Date Range',
      status: 'Filter by Status',
      customer: 'Filter by Customer',
      driver: 'Filter by Driver',
      applyFilters: 'Apply Filters',
      clearFilters: 'Clear Filters',
      statusLabel: 'Status',
      searchPlaceholder: 'Search shipments...',
      filters: {
        status: 'Status',
        all: 'All Statuses'
      }
    },
    
    // Tracking functionality
    tracking: {
      title: 'Track Shipment',
      enterTrackingNumber: 'Enter tracking number',
      track: 'Track',
      status: 'Status',
      currentLocation: 'Current Location',
      estimatedDelivery: 'Estimated Delivery',
      history: 'Tracking History',
      noHistory: 'No tracking history available',
      timestamp: 'Timestamp',
      event: 'Event',
      notes: 'Notes'
    }
  },

  // Zones module
  zones: {
    title: 'Shipping Zones',
    createNew: 'New Zone',
    editZone: 'Edit Zone',
    
    // Field labels
    fields: {
      id: 'ID',
      name: 'Zone Name',
      region: 'Region',
      pricePerKg: 'Price per Kg',
      createdAt: 'Created At',
      updatedAt: 'Updated At'
    },
    
    // Regions
    regions: {
      national: 'National',
      westAfrica: 'West Africa',
      centralAfrica: 'Central Africa',
      international: 'International'
    },
    
    // Placeholders
    placeholders: {
      name: 'e.g., Ouagadougou Local, Ghana International'
    },
    
    // Statistics
    stats: {
      total: 'Total Zones',
      national: 'National Zones',
      international: 'International Zones',
      averagePrice: 'Average Price'
    },
    
    // Messages
    messages: {
      loading: 'Loading zones...',
      error: 'Error loading zones',
      noZones: 'No zones found',
      created: 'Zone created successfully',
      updated: 'Zone updated successfully',
      deleted: 'Zone deleted successfully',
      createError: 'Failed to create zone',
      updateError: 'Failed to update zone',
      deleteError: 'Failed to delete zone'
    },
    
    // Delete confirmation
    deleteDialog: {
      title: 'Delete Zone',
      content: 'Are you sure you want to delete the zone "{{name}}"? This action cannot be undone.'
    }
  },

  // Customers module
  customers: {
    title: 'Customers',
    createNew: 'New Customer',
    createCustomer: 'Create Customer',
    editCustomer: 'Edit Customer',
    searchPlaceholder: 'Search customers...',
    noCustomers: 'No customers found',
    noSearchResults: 'No customers match your search',
    
    // Field labels
    fields: {
      id: 'ID',
      user: 'User Account',
      companyName: 'Company Name',
      contactPerson: 'Contact Person',
      phone: 'Phone Number',
      alternatePhone: 'Alternate Phone',
      email: 'Email',
      website: 'Website',
      status: 'Status',
      notes: 'Notes',
      totalShipments: 'Total Shipments',
      totalSpent: 'Total Spent',
      lastShipment: 'Last Shipment',
      createdAt: 'Created At',
      updatedAt: 'Updated At',
      addressType: 'Address Type',
      addressLabel: 'Address Label',
      addressLine1: 'Address Line 1',
      addressLine2: 'Address Line 2',
      city: 'City',
      state: 'State',
      postalCode: 'Postal Code',
      country: 'Country'
    },
    
    // Status options
    status: {
      active: 'Active',
      inactive: 'Inactive',
      suspended: 'Suspended'
    },
    
    // Address types
    addressType: {
      billing: 'Billing',
      shipping: 'Shipping',
      both: 'Both'
    },
    
    // Statistics
    stats: {
      totalCustomers: 'Total Customers',
      activeCustomers: 'Active Customers',
      inactiveCustomers: 'Inactive Customers',
      totalRevenue: 'Total Revenue',
      averageOrderValue: 'Average Order Value'
    },
    
    // Sections
    sections: {
      companyInfo: 'Company Information',
      statistics: 'Customer Statistics',
      addresses: 'Addresses',
      shipmentHistory: 'Shipment History'
    },
    
    // Actions
    addAddress: 'Add Address',
    editAddress: 'Edit Address',
    defaultAddress: 'Default',
    noAddresses: 'No addresses found',
    noShipments: 'No shipments found',
    
    // Messages
    messages: {
      created: 'Customer created successfully',
      updated: 'Customer updated successfully',
      deleted: 'Customer deleted successfully',
      addressAdded: 'Address added successfully',
      addressUpdated: 'Address updated successfully',
      addressDeleted: 'Address deleted successfully',
      loadError: 'Failed to load customer data',
      shipmentsLoadError: 'Failed to load customer shipments',
      createError: 'Failed to create customer',
      updateError: 'Failed to update customer',
      deleteError: 'Failed to delete customer',
      addressAddError: 'Failed to add address',
      addressUpdateError: 'Failed to update address',
      addressDeleteError: 'Failed to delete address',
      loadUsersError: 'Failed to load users',
      confirmDelete: 'Are you sure you want to delete {{name}}?',
      notFound: 'Customer not found',
      error: 'Error loading customers'
    }
  },
  // Dashboard translations
  dashboard: {
    title: 'Admin Dashboard',
    welcome: 'Welcome',
    logout: 'Logout',
    overview: 'Overview',
    profile: 'Profile',
    settings: 'Settings',
    accountSettings: 'Account Settings',
    
    // Time-based greetings
    goodMorning: 'Good Morning',
    goodAfternoon: 'Good Afternoon',
    goodEvening: 'Good Evening',
    
    // Admin dashboard
    totalShipments: 'Total Shipments',
    activeDrivers: 'Active Drivers',
    monthlyRevenue: 'Monthly Revenue',
    pendingShipments: 'Pending Shipments',
    revenueChart: 'Revenue Trends',
    shipmentDistribution: 'Shipment Distribution',
    driversOverview: 'Drivers Overview',
    recentActivities: 'Recent Activities',
    viewAllReports: 'View All Reports',
    manageUsers: 'Manage Users',
    systemHealth: 'System Health',
    
    // Driver dashboard
    totalDeliveries: 'Total Deliveries',
    todaysDeliveries: 'Today\'s Deliveries',
    currentStatus: 'Current Status',
    rating: 'Rating',
    todaysEarnings: 'Today\'s Earnings',
    thisWeek: 'This Week',
    thisMonth: 'This Month',
    activeShipments: 'Active Shipments',
    updateLocation: 'Update Location',
    viewAssignments: 'View Assignments',
    yourRecentActivities: 'Your Recent Activities',
    shipmentsAssigned: 'shipments assigned',
    keepCustomersInformed: 'Keep customers informed',
    tapToChange: 'Tap to change',
    customerRating: 'Customer Rating',
    vsYesterday: 'vs yesterday',
    available: 'Available',
    busy: 'Busy',
    offline: 'Offline',
    
    // Status messages
    loading: 'Loading dashboard data...',
    error: 'Failed to load dashboard data',
    noData: 'No data available'
  },

  // Access control translations
  access: {
    denied: 'Access Denied',
    driverRestriction: 'As a driver, you can only access the dashboard and driver management pages. Other pages are restricted to administrators only.',
    allowedPages: 'Allowed pages',
    goToDashboard: 'Go to Dashboard'
  },

  // CRUD translations (top-level for components using t('crud.*'))
  crud: {
    create: 'Create',
    actions: 'Actions',
    edit: 'Edit',
    delete: 'Delete',
    cannotDeleteAdmin: 'Cannot delete admin user'
  }
};

export default translations;
